import { getDefaultLocale } from '../../utils/translationUtils'

import { usePageContext } from './usePageContext'

export default function useLocale() {
  return usePageContext()?.locale ?? getDefaultLocale()
}
